import React from "react";
import VerifiedsPage from "../Components/SignIN_SignUP/page_verify";
function VerifPage() {
  return <VerifiedsPage />;
}

export default VerifPage;
